module.exports = __webpack_public_path__ + "static/media/lohono-story.722e7e43.jpg";